import React from 'react';
import connectToStores from 'alt-store-connect';
import jwtDecode from 'jwt-decode';
import Login from './authentication/login';
import LoginLocal from './authentication/LoginLocal';
import Notifications from './notifications/Notifications';
import TenantSelect from './tenant-select';
import EditorStore from '../stores/editor';
import Tooling from './baseComponents/Tooling';
import GovernmentPolicy from './authentication/GovernmentPolicy';
import translations from '../translations';
import { setCurrentUser } from '../actions/reduxActions/currentUser';
import { OKTA_ENABLED } from '../constants';

import { hot } from 'react-hot-loader';
import { fetchCurrentTenant } from '../actions/reduxActions/currentTenant';
import { HOSTS } from '../constants';
import { connect } from 'react-redux';
import { Router } from '@reach/router';

import '../../css/global-styles.less';
import '../../css/draw.less';

const { pendo } = window;

/**
 * The Draw component contains the base Router for the application. This enables the following url
 * routing hierarchy:
 *  - /
 *      - /:tenant-id
 *          - /:tenant-id/:admin-tab
 *          - /:tenant-id/flows/:flow-id
 *          - /:tenant-id/pages/:page-id
 */
@connectToStores
export class Draw extends React.Component {
    static getStores() {
        return [EditorStore];
    }

    static getPropsFromStores() {
        return {
            editor: EditorStore.getState(),
        };
    }

    state = {
        acceptedGovernmentPolicy: false,
        isGovernmentUrl: window.location.hostname === HOSTS.federal,
    };

    componentDidMount() {
        const { authenticationToken, tenantId, tenantName, orgId, orgName } =
            this.props.currentUser;

        if (authenticationToken) {
            const userClaims = jwtDecode(authenticationToken);

            // When the user refreshes the page, we initialized pendo with the user in the session
            if (pendo && userClaims && !pendo.visitorId && orgId !== undefined) {
                pendo.initialize({
                    visitor: {
                        id: userClaims.sub,
                        email: userClaims.email,
                        full_name: `${userClaims.given_name} ${userClaims.family_name}`,
                    },
                    account: {
                        id: tenantId,
                        name: tenantName,
                    },
                    parentAccount: {
                        id: orgId ?? 'no-organization',
                        name: orgName ?? null,
                    },
                });
            }
        }
    }

    acceptGovernmentPolicy = () => this.setState({ acceptedGovernmentPolicy: true })

    render() {
        const userClaims = this.props.currentUser.authenticationToken
            ? jwtDecode(this.props.currentUser.authenticationToken)
            : null;
        const isAuthenticated = userClaims && !!userClaims.email;
        const urlParams = new URLSearchParams(window.location.search);

        const tokenFromUrl = urlParams.has('token');
        if (!isAuthenticated && !tokenFromUrl) {
            if (this.state.acceptedGovernmentPolicy === false && this.state.isGovernmentUrl) {
                return <GovernmentPolicy acceptGovernmentPolicy={this.acceptGovernmentPolicy} />;
            }

            return (OKTA_ENABLED === 'true') ? <Login /> : <LoginLocal />;
        }

        if (tokenFromUrl) {
            return null;
        }

        return (
            <>
                <Router className="full-screen-app-wrapper">
                    <Tooling
                        path="/*"
                        isAuthenticated={isAuthenticated}
                        currentLoggedInTenantId={this.props.currentUser.tenantId}
                        authenticationToken={this.props.currentUser.authenticationToken}
                        editors={this.props.editor.editors}
                        isTenantSelectorOpen={this.props.editor.isTenantSelectorOpen}
                        container={this}
                    />
                </Router>
                <div id="generic-modal" />
            </>
        );
    }
}

const mapDispatchToProps = {
    fetchCurrentTenant
};

export default connect(
    ({ currentUser }) => ({ currentUser }),
    mapDispatchToProps,
)(hot(module)(Draw));
